import React from 'react';
import useFormAPI from '../api';
import uuid from 'uuid';
import apiClients from '../../../../utils/apiClients';

var FormStyle = function FormStyle() {
  var formApi = useFormAPI();
  React.useEffect(function () {
    var state = formApi.state;
    var formRootField = formApi.state.fields[state.formId];
    var cssContent = formRootField.cssContent;
    if (!cssContent) return;
    var stylesheetId = uuid();
    var stylesheet = document.createElement('style');
    stylesheet.setAttribute('id', stylesheetId);
    stylesheet.innerText = atob(cssContent);
    document.head.appendChild(stylesheet);
    return function cleanup() {
      var stylesheet = document.getElementById(stylesheetId);
      if (stylesheet) document.head.removeChild(stylesheet);
    };
  }, []);
  return null;
};

export default FormStyle;